function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "mail_1_",
  "data-name": "mail(1)",
  transform: "translate(0.151 -4.332)"
}, React.createElement("g", {
  id: "Group_2229",
  "data-name": "Group 2229",
  transform: "translate(3.872 10.668)"
}, React.createElement("path", {
  id: "Path_3345",
  "data-name": "Path 3345",
  d: "M21.683,18a.224.224,0,0,1-.155-.061l-2.6-2.44a.226.226,0,1,1,.31-.329l2.6,2.44a.226.226,0,0,1-.155.391Z",
  transform: "translate(-12.773 -15.111)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_3346",
  "data-name": "Path 3346",
  d: "M5.628,18a.226.226,0,0,1-.155-.391l2.6-2.44a.226.226,0,1,1,.31.329l-2.6,2.44A.224.224,0,0,1,5.628,18Z",
  transform: "translate(-5.402 -15.112)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
})), React.createElement("path", {
  id: "Path_3347",
  "data-name": "Path 3347",
  d: "M15.519,16.482H1.361A1.362,1.362,0,0,1,0,15.121V5.843A1.362,1.362,0,0,1,1.361,4.482H15.519A1.362,1.362,0,0,1,16.88,5.843v9.279A1.362,1.362,0,0,1,15.519,16.482ZM1.361,5.026a.817.817,0,0,0-.816.816v9.279a.817.817,0,0,0,.816.816H15.519a.817.817,0,0,0,.816-.816V5.843a.817.817,0,0,0-.816-.816Z",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_3348",
  "data-name": "Path 3348",
  d: "M8.8,11.038a1.743,1.743,0,0,1-1.007-.3L.753,5.675a.2.2,0,0,1-.027-.319.319.319,0,0,1,.387-.022L8.155,10.4a1.2,1.2,0,0,0,1.293,0l7.033-5.055a.317.317,0,0,1,.387.022.2.2,0,0,1-.026.319L9.808,10.738A1.741,1.741,0,0,1,8.8,11.038Z",
  transform: "translate(-0.361 -0.437)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}));
var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 17.18,
    height: 12.3,
    viewBox: "0 0 17.18 12.3",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.04b5911e.svg";
export { ForwardRef as ReactComponent };